import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Members from './pages/Members';
import Music from './pages/Music';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/members" element={<Members />} />
      <Route path="/music" element={<Music />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;